import { render, staticRenderFns } from "./ResultsAuthorizationWhitelistTable.vue?vue&type=template&id=45eb8bc4"
import script from "./ResultsAuthorizationWhitelistTable.vue?vue&type=script&lang=js"
export * from "./ResultsAuthorizationWhitelistTable.vue?vue&type=script&lang=js"
import style0 from "./ResultsAuthorizationWhitelistTable.vue?vue&type=style&index=0&id=45eb8bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports